import Vue from 'vue'
import App from './App.vue'

new Vue({
  el: '#app',
  render(createElement) {
    return createElement(App, {
      props: {
        allChoices: vueLocalize.allChoices,
        choiceRules: vueLocalize.choiceRules
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js